/* eslint-disable prefer-destructuring */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import cardUsage from '../../utils/cardUsage';
import {
  BUDGET_REQUEST_UPDATE_GQL,
  GET_NOTIFICATION_SPEND_AMOUNT_GQL,
  ALLOCATED_USER_TRANSACTIONS_GQL2,
  GET_CATEGORY_ALLOCATED_BUDGET,
  ALLOCATE_BUDGET_CAT_GQL,
  GET_NOTIFICATION_BUDGET_REQUEST_GQL,
  GET_GROUPS_BUDGET_GQL,
  GET_TOTAL_SPEND_TEAM_GQL,
  GET_LEDGER_BALANCE_GQL,
  ALLOCATE_TRANSACTIONS_GQL2,
  GET_BUDGET_ALLOCATED_GQL,
  GET_USER_TOTAL_BALANCE_GQL,
  GET_CARD_USAGE_GQL,
  GET_CARD_USAGE_BY_USER_GQL,
  CREATE_LEDGERBALANCE_GQL,
  GET_TOTAL_BALANCE_GQL,
  GET_USER_CATEGORY_ALLOCATED_BUDGET,
  ALLOCATE_BUDGET_GQL2,
  UPDATE_USER_BUDGET_GQL,
  ALLOCATED_TRANSACTIONS_GQL2,
  GET_USER_ALLOCATED_AMOUNT_GQL,
  GET_CATEGORY_BUDGET_GQL,
  GET_ALL_TEAM_BUDGET_GQL,
  GET_ALL_TEAM_BUDGET_MONTHLY_GQL,
  GET_YEAR_UNCATEGORISE,
  GET_TOP_MERCHANT_AVERAGE_INCREASE_DATA_GQL,
  GET_CHECK_EXT_CARD,
  SET_CHECK_EXT_CARD,
} from '@/graphql/queries.gql';


export default {
  namespaced: true,

  state: {
    // = data
    teamSpendBudgetAmount2: '',
    globalGroup: localStorage.getItem('globalGroupId'),
    NotificationRequests: [],
    UpdateRequest: [],
    SpendNotification: [],
    allocatedGroupBudget: [],
    groupsBudgets: [],
    spendAmount: [],
    cardUsages: [],
    allocatedBudget: [],
    updateBalance: [],
    spendTransaction: [],
    allocatBudget: [],
    catMonthBudget: [],
    getListOfUnCategorize: null,
    moveTransaction: null,
    topMerchantAverageIncreaseData: null,
    isExtConnected: false,
  },

  mutations: {
    SET_EXT(state, payload) {
      state.isExtConnected = payload;
    },
    GET_TOP_MERCHANT_AVERAGE_INCREASE_DATA(state, payload) {
      state.topMerchantAverageIncreaseData = payload;
    },
    SET_AMOUNT_BUDGET(state, payload) {
      state.teamSpendBudgetAmount2 = payload;
    },
    SET_NOTIFICATION_REQUEST(state, payload) {
      state.NotificationRequests = payload;
    },
    SET_UPDATE_REQUEST(state, payload) {
      state.UpdateRequest = payload;
    },
    SET_NOTIFICATION_SPEND(state, payload) {
      state.SpendNotification = payload;
    },
    SET_MY_ALLOCATED_BUDGET(state, payload) {
      state.allocatedGroupBudget = payload;
    },
    SET_MY_GROUPS_BUDGET(state, payload) {
      state.groupsBudgets = payload;
    },
    SET_TOTAL_SPEND_AMOUNT(state, payload) {
      state.spendAmount = payload;
    },
    SET_CARD_USAGE_DATA(state, payload) {
      state.cardUsages = payload;
    },
    SET_BUDGET_ALLOCATE_AMOUNT(state, payload) {
      state.allocatedBudget = payload;
    },
    SET_UPDATE_BALANCE(state, payload) {
      state.updateBalance = payload;
    },
    SET_SPEND_TRANSACTION(state, payload) {
      state.spendTransaction = payload;
    },
    SET_BUDGET_ALLOCATE2_AMOUNT(state, payload) {
      state.allocatBudget = payload;
    },
    SET_CAT_BUDGET(state, payload) {
      state.catMonthBudget = payload;
    },
    SET_UNCATEGORIZE(state, payload) {
      state.getListOfUnCategorize = payload;
    },
    SET_STATE_TRANSACTION(state, payload) {
      state.moveTransaction = payload;
    },
  },

  actions: {
    // Notification PopUp Data
    getNotificationPopup({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_NOTIFICATION_BUDGET_REQUEST_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(( getNotificationPopupData ) => {
          const requestData = {};
          requestData.id = getNotificationPopupData.data.budgetrequests[0].id;
          requestData.amount = getNotificationPopupData.data.budgetrequests[0].amount;
          requestData.requestDate = getNotificationPopupData.data.budgetrequests[0].requestDate;
          requestData.note = getNotificationPopupData.data.budgetrequests[0].note;
          requestData.groupName = getNotificationPopupData.data.budgetrequests[0].group.groupName;
          if (getNotificationPopupData.data.budgetrequests[0].category !== null) {
            requestData.categoryName = getNotificationPopupData.data.budgetrequests[0].category.categoryName;
          }
          requestData.userName = getNotificationPopupData.data.budgetrequests[0].user.firstName;
          requestData.email = getNotificationPopupData.data.budgetrequests[0].user.email;
          requestData.userPhoto = getNotificationPopupData.data.budgetrequests[0].user.userPhoto;
          requestData.month = getNotificationPopupData.data.budgetrequests[0].month;
          requestData.year = getNotificationPopupData.data.budgetrequests[0].year;
          requestData.requestStatus = getNotificationPopupData.data.budgetrequests[0].reqStatus;
          commit('SET_NOTIFICATION_REQUEST', requestData);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getNotificationPopupErr) => {
          console.log(getNotificationPopupErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getCatBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_CATEGORY_BUDGET_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then(( getCatBudgetData ) => {
          commit('SET_CAT_BUDGET', getCatBudgetData.data.categorybudgets[0]);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getCatBudgetErr) => {
          console.log(getCatBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Update Budget Request
    async updateBudgetRequest({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: BUDGET_REQUEST_UPDATE_GQL,
          variables: {
            id: payload.id,
            reqStatus: payload.reqStatus,
          },
        })
        .then(({ data }) => {
          if (payload.reqStatus === 1) {
            const balanceArry = [];
            balanceArry.userId = data.updateBudgetrequest.userId;
            balanceArry.groupId = data.updateBudgetrequest.groupId;
            balanceArry.amount = data.updateBudgetrequest.amount;
            balanceArry.categoryId = data.updateBudgetrequest.categoryId;
            apolloClient
              .query({
                query: GET_TOTAL_BALANCE_GQL,
                variables: {
                  userId: balanceArry.userId,
                  categoryId: balanceArry.categoryId,
                },
                fetchPolicy: 'cache-first',
              })
              .then(({ data }) => {
                if (data.ledgerBalances.length > 0) {
                  balanceArry.Balance = data.ledgerBalances.Balance;
                } else {
                  balanceArry.Balance = 0;
                }
                apolloClient
                  .query({
                    query: GET_USER_TOTAL_BALANCE_GQL,
                    variables: {
                      id: balanceArry.userId,
                      month: payload.month,
                      year: payload.year,
                      categoryId: balanceArry.categoryId,
                      groupId: balanceArry.groupId,
                      last: 1,
                    },
                    fetchPolicy: 'cache-first',
                  })
                  .then(({ data }) => {
                    if (data.user.ledgerBalance.length > 0) {
                      balanceArry.totalBalance = data.user.ledgerBalance[0].totalBalance;
                    } else {
                      balanceArry.totalBalance = 0;
                    }
                    balanceArry.totalsum = balanceArry.totalBalance + balanceArry.amount;
                    balanceArry.amountBalance = balanceArry.Balance + balanceArry.amount;
                    if (data.user.userbudgets.length > 0) {
                      balanceArry.userBudgetAmount = data.user.userbudgets[0].amount + balanceArry.amount;
                      balanceArry.UserBudgetId = data.user.userbudgets[0].id;
                    }
                    apolloClient
                      .mutate({
                        mutation: UPDATE_USER_BUDGET_GQL,
                        variables: {
                          id: balanceArry.UserBudgetId,
                          amount: balanceArry.userBudgetAmount,
                          userId: balanceArry.userId,
                          groupId: balanceArry.groupId,
                          categoryId: balanceArry.categoryId,
                        },
                      }).then(({ data }) => {
                        apolloClient
                          .mutate({
                            mutation: CREATE_LEDGERBALANCE_GQL,
                            variables: {
                              userId: balanceArry.userId,
                              groupId: balanceArry.groupId,
                              categoryId: balanceArry.categoryId,
                              instrumentType: '',
                              debitAmount: 0.0,
                              year: payload.year,
                              month: payload.month,
                              Balance: balanceArry.amountBalance,
                              totalBalance: balanceArry.totalsum,
                              creditAmount: balanceArry.amount,
                            },
                            refetchQueries: () => [
                              {
                                query: GET_TOTAL_BALANCE_GQL,
                                variables: {
                                  userId: balanceArry.userId,
                                  categoryId: balanceArry.categoryId,
                                },
                              },
                              {
                                query: GET_USER_TOTAL_BALANCE_GQL,
                                variables: {
                                  id: balanceArry.userId,
                                  month: payload.month,
                                  year: payload.year,
                                  categoryId: balanceArry.categoryId,
                                  groupId: balanceArry.groupId,
                                  last: 1,
                                },
                              },
                            ],
                          })
                          .then(({ data }) => {
                            // This is for future 
                          });
                      });
                  });
              });
          }
          commit('SET_UPDATE_REQUEST', data.updateBudgetrequest);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    // Spend Amount for Notification
    notificationSpendAmount({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .query({
          query: GET_NOTIFICATION_SPEND_AMOUNT_GQL,
          variables: payload,
        })
        .then(( notificationSpendAmountData ) => {
          const balanceData = [];
          notificationSpendAmountData.data.users.forEach((user) => {
            const userList = {};
            if (user.userbudgets.length > 0) {
              userList.allocated = user.userbudgets[0].amount;
            } else {
              userList.allocated = 0;
            }
            let totalSpend = 0;
            user.userExpenses.forEach((expense) => {
              totalSpend += expense.amount;
            });
            userList.spend = totalSpend;
            userList.available = userList.allocated - userList.spend;
            balanceData.push(userList);
          });
          commit('SET_NOTIFICATION_SPEND', balanceData[0]);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((notificationSpendAmountErr) => {
          console.log(notificationSpendAmountErr);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },

    // Allocated Total Budget
    getAllocatedBudget({ commit }, payload) {
      payload.teamList.forEach((teams) => {
        if (payload.userRole === 'Manager' || payload.userRole === 'Admin' || teams.team.groupName === 'All Teams') {
          apolloClient
            .query({
              query: GET_CATEGORY_ALLOCATED_BUDGET,
              variables: payload,
            })
            .then(( getAllocatedBudgetData) => {
              let allocatedAmount = 0;
              const budgetallocate = {};
              getAllocatedBudgetData.data.groups.forEach((group) => {
                group.categories.forEach((category) => {
                  category.categorybudgets.forEach((catBudget) => {
                    allocatedAmount += catBudget.amount;
                  });
                });
              });
              budgetallocate.amount = allocatedAmount;
              commit('SET_MY_ALLOCATED_BUDGET', budgetallocate);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((getAllocatedBudgetErr) => {
              console.log(getAllocatedBudgetErr);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        } else {
          apolloClient
            .query({
              query: GET_USER_CATEGORY_ALLOCATED_BUDGET,
              variables: payload,
            })
            .then(( getAllocatedBudgetElseCaseData ) => {
              let allocatedAmount = 0;
              const budgetallocate = {};
              getAllocatedBudgetElseCaseData.data.groups.forEach((group) => {
                group.categories.forEach((category) => {
                  category.categorybudgets.forEach((catBudget) => {
                    allocatedAmount += catBudget.amount;
                  });
                });
              });
              budgetallocate.amount = allocatedAmount;
              commit('SET_MY_ALLOCATED_BUDGET', budgetallocate);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((getAllocatedBudgetElseCaseErr) => {
              console.log(getAllocatedBudgetElseCaseErr);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
      });
    },

    // Total Group Budget
    getGroupsBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_GROUPS_BUDGET_GQL,
          variables: payload,
        })
        .then(( getGroupsBudgetData) => {
          let budgetAmount = 0;
          const budget = {};
          getGroupsBudgetData.data.groups.forEach((group) => {
            group.groupbudgets.forEach((groupBudget) => {
              budgetAmount += groupBudget.amount;
            });
          });
          budget.amount = budgetAmount;
          commit('SET_MY_GROUPS_BUDGET', budget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getGroupsBudgetErr) => {
          console.log(getGroupsBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Get Total Spend
    getGroupTotalSpend({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.teamList.forEach((teams) => {
        if (payload.userRole === 'Manager' || payload.userRole === 'Admin' || teams.team.groupName === 'All Teams') {
          apolloClient
            .query({
              query: GET_TOTAL_SPEND_TEAM_GQL,
              variables: payload,
            })
            .then(( getGroupTotalSpendData) => {
              let totalBudget = 0;
              if (getGroupTotalSpendData.data.groups.length > 0) {
                if (getGroupTotalSpendData.data.groups[0].groupbudgets.length > 0) {
                  getGroupTotalSpendData.data.groups[0].groupbudgets.forEach((budget) => {
                    totalBudget += budget.amount;
                  });
                }
              }

              apolloClient
                .query({
                  query: ALLOCATED_TRANSACTIONS_GQL2,
                  variables: payload,
                })
                .then(( getGroupTotalSpend2data ) => {
                  const groupList = {};
                  let totalExpense = 0;
                  getGroupTotalSpend2data.data.userExpenses.forEach((expenses) => {
                    totalExpense += expenses.amount;
                  });
                  groupList.allocated = totalBudget;
                  groupList.expense = totalExpense;
                  groupList.available = totalBudget - totalExpense;
                  commit('SET_TOTAL_SPEND_AMOUNT', groupList);
                  commit('shared/SET_LOADING', false, { root: true });
                })
                .catch((getGroupTotalSpendErr) => {
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                  console.log(getGroupTotalSpendErr);
                });
            });
        } else {
          apolloClient
            .query({
              query: GET_TOTAL_SPEND_TEAM_GQL,
              variables: payload,
            })
            .then(( getGroupTotalSpendData2 ) => {
              let totalBudget = 0;
              if (getGroupTotalSpendData2.data.groups.length > 0) {
                if (getGroupTotalSpendData2.data.groups[0].groupbudgets.length > 0) {
                  getGroupTotalSpendData2.data.groups[0].groupbudgets.forEach((budget) => {
                    totalBudget += budget.amount;
                  });
                }
              }
              apolloClient
                .query({
                  query: ALLOCATED_USER_TRANSACTIONS_GQL2,
                  variables: payload,
                })
                .then(( getGroupTotalSpendData2data ) => {
                  const groupList = {};
                  let totalExpense = 0;
                  getGroupTotalSpendData2data.data.userExpenses.forEach((expenses) => {
                    totalExpense += expenses.amount;
                  });
                  groupList.allocated = totalBudget;
                  groupList.expense = totalExpense;
                  groupList.available = totalBudget - totalExpense;
                  commit('SET_TOTAL_SPEND_AMOUNT', groupList);
                  commit('shared/SET_LOADING', false, { root: true });
                })
                .catch((getGroupTotalSpend2err) => {
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                  console.log(getGroupTotalSpend2err);
                });
            });
        }
      });
    },
    // Getting Card Usage Data
    getCardUsageData({ commit }, payload) {
      let queryVariable;
      let payloads;
      let flag = 1;
      payload.teams.forEach((teamList) => {
        if (teamList.team.slug === 'all-teams') {
          teamList.permissions2.forEach((perm) => {
            if (perm.slug === 'view_team_transactions') {
              flag = 2;
            }
          });
        }
      });
      if (flag === 2) {
        queryVariable = GET_CARD_USAGE_GQL;
        payloads = {
          month: payload.month,
          year: payload.year,
          teamId: payload.teamIds,
          status: true,
        };
        apolloClient
          .query({
            query: queryVariable,
            variables: payloads,
            refetchQueries: [queryVariable],
            fetchPolicy: 'network-only',
          })
          .then(( CardUsageGQLData ) => {
            let cardUsageData = [];
            cardUsageData = cardUsage(CardUsageGQLData.data, cardUsageData);
            commit('SET_CARD_USAGE_DATA', cardUsageData);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          })
          .catch((CardUsageGQLErr) => {
            console.log(CardUsageGQLErr);
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
      }

      if (flag === 1) {
        let isManager = false;
        let isEmp = false;
        const tempTeamIds = [];
        const tempTeamIds2 = [];
        let chkPerm = false;
        payload.teams.forEach((teamList) => {
          chkPerm = false;
          teamList.permissions2.forEach((perm) => {
            if (perm.slug === 'view_team_transactions') {
              chkPerm = true;
            }
          });
          if (chkPerm === true) {
            tempTeamIds.push(teamList.team.id);
            isManager = true;
          } else {
            tempTeamIds2.push(teamList.team.id);
            isEmp = true;
          }
        });
        let cardUsageData = [];
        // for manager
        if (isManager) {
          queryVariable = GET_CARD_USAGE_GQL;
          payloads = {
            month: payload.month,
            year: payload.year,
            teamId: tempTeamIds,
            status: true,
          };
          apolloClient
            .query({
              query: queryVariable,
              variables: payloads,
              refetchQueries: [queryVariable],
              fetchPolicy: 'network-only',
            })
            .then(({ data }) => {
              cardUsageData = cardUsage(data, cardUsageData);
              commit('SET_CARD_USAGE_DATA', cardUsageData);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
        if (isEmp) {
          queryVariable = GET_CARD_USAGE_BY_USER_GQL;
          payloads = {
            month: payload.month,
            year: payload.year,
            userId: payload.userId,
            status: true,
          };
          apolloClient
            .query({
              query: queryVariable,
              variables: payloads,
              refetchQueries: [queryVariable],
              fetchPolicy: 'no-cache',
            })
            .then(({ data }) => {
              cardUsageData = cardUsage(data, cardUsageData);
              commit('SET_CARD_USAGE_DATA', cardUsageData);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
      }
    },

    // Getting budget data for Donut chart
    getAllocatedBudgetAmount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.teamList.forEach((teams) => {
        if (payload.userRole === 'Manager' || payload.userRole === 'Admin' || teams.team.groupName === 'All Teams') {
          apolloClient
            .query({
              query: GET_BUDGET_ALLOCATED_GQL,
              variables: payload,
              fetchPolicy: 'network-only',
            })
            .then(({ data }) => {
              const userList = {};
              if (data.groups[0].groupbudgets.length > 0) {
                userList.groupbudget = data.groups[0].groupbudgets[0].amount;
              } else {
                userList.groupbudget = 0;
              }
              let totalBudget = 0;
              data.groups[0].categories.forEach((category) => {
                category.categorybudgets.forEach((budgets) => {
                  totalBudget += budgets.amount;
                });
              });
              userList.expense = totalBudget;
              userList.available = userList.groupbudget - totalBudget;
              commit('SET_BUDGET_ALLOCATE_AMOUNT', userList);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        } else if (payload.userRole === 'Employee') {
          apolloClient
            .query({
              query: GET_USER_ALLOCATED_AMOUNT_GQL,
              variables: {
                userId: payload.loggedinUserId,
                teamId: payload.groupId,
                month: payload.month,
                year: payload.year,
              },
            }).then(({ data }) => {
              const groupBudget = {};
              data.users.forEach((user) => {
                if (user.userbudgets.length > 0) {
                  user.userbudgets.forEach((budget) => {
                    groupBudget.totalBudget = budget.amount;
                  });
                } else {
                  groupBudget.totalBudget = 0;
                }
                if (user.userExpenses.length > 0) {
                  user.userExpenses.forEach((expense) => {
                    groupBudget.expense = expense.amount;
                  });
                } else {
                  groupBudget.expense = 0;
                }
              });
              groupBudget.available = groupBudget.totalBudget - groupBudget.expense;

              commit('SET_BUDGET_ALLOCATE_AMOUNT', groupBudget);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            }).catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
      });
    },

    getAllocateUserBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: ALLOCATE_BUDGET_GQL2,
          variables: payload,
        })
        .then(({ data }) => {
          let totalBudget = 0;
          data.userbudgets.forEach((budget) => {
            totalBudget += budget.amount;
          });

          apolloClient
            .query({
              query: ALLOCATE_BUDGET_CAT_GQL,
              variables: {
                groupId: payload.groupId,
                recordStatus: 1,
                flag: 1,
                month: payload.month,
                year: payload.year,
              },
            }).then(({ data }) => {
              const groupBudget = {};
              if (data.group.groupbudgets.length > 0) {
                groupBudget.totalbudget = data.group.groupbudgets[0].amount;
              } else {
                groupBudget.totalbudget = 0;
              }

              groupBudget.expense = totalBudget;
              groupBudget.available = groupBudget.totalbudget - totalBudget;
              commit('SET_BUDGET_ALLOCATE2_AMOUNT', groupBudget);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Update Budget Request Amount
    getUpdateBalance({ commit }, payload) {
      console.log('getUpdateBalance');
      const promises = [];
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_LEDGER_BALANCE_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          const userList = {};
          if (data.user.ledgerBalance.length > 0) {
            userList.Balance = data.user.ledgerBalance[0].Balance;
          } else {
            userList.Balance = 0;
          }

          promises.push(
            apolloClient
              .query({
                query: GET_USER_TOTAL_BALANCE_GQL,
                variables: {
                  id: data.user.id,
                  month: payload.month,
                  year: payload.year,
                },
              })
              .then(({ data }) => {
                if (data.user.ledgerBalance.length > 0) {
                  userList.totalBalance = data.user.ledgerBalance[0].totalBalance;
                } else {
                  userList.totalBalance = 0;
                }
                commit('SET_UPDATE_BALANCE', userList);
                commit('shared/SET_LOADING', false, {
                  root: true,
                });
              }),
          );
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    getTransactionsSpend({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.teamList.forEach((teams) => {
        if (teams.team.groupName === 'All Teams') {
          apolloClient
            .query({
              query: ALLOCATE_BUDGET_CAT_GQL,
              variables: payload,
            })
            .then(({ data }) => {
              let totalBudget = 0;
              data.group.groupbudgets.forEach((budget) => {
                totalBudget += budget.amount;
              });

              apolloClient
                .query({
                  query: ALLOCATE_TRANSACTIONS_GQL2,
                  variables: {
                    groupId: payload.groupId,
                    month: payload.month,
                    year: payload.year,
                  },
                }).then(({ data }) => {
                  let totalExpense = 0;
                  data.userExpenses.forEach((expenses) => {
                    totalExpense += expenses.amount;
                  });
                  const groupBudget = {};
                  groupBudget.allocated = totalBudget;
                  groupBudget.expense = totalExpense;
                  groupBudget.available = totalBudget - totalExpense;
                  commit('SET_SPEND_TRANSACTION', groupBudget);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                });
            })
            .catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        } else {
          apolloClient
            .query({
              query: GET_USER_ALLOCATED_AMOUNT_GQL,
              variables: {
                userId: payload.loggedinUserId,
                teamId: payload.groupId,
                month: payload.month,
                year: payload.year,
              },
            }).then(({ data }) => {
              const groupBudget = {};
              data.users.forEach((user) => {
                if (user.userbudgets.length > 0) {
                  user.userbudgets.forEach((budget) => {
                    groupBudget.allocated = budget.amount;
                  });
                } else {
                  groupBudget.allocated = 0;
                }
                if (user.userExpenses.length > 0) {
                  user.userExpenses.forEach((expense) => {
                    groupBudget.expense = expense.amount;
                  });
                } else {
                  groupBudget.expense = 0;
                }
              });
              groupBudget.available = groupBudget.allocated - groupBudget.expense;

              commit('SET_SPEND_TRANSACTION', groupBudget);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            }).catch((err) => {
              console.log(err);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
        }
      });
    },
    async getAllTeamBudgetMonthly({ commit }, payload) {

      await apolloClient
        .query({
          query: GET_ALL_TEAM_BUDGET_MONTHLY_GQL,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then(({
          data,
        }) => {

          const {
            totalBudget,
            totalAllocated,
            totalSpent,
            totalUncatorized,
          } = data.getAllTeamDashboardMonthWise;
          commit('SET_BUDGET_ALLOCATE_AMOUNT', {
            expense: totalAllocated,
            available: totalBudget - totalAllocated,
            groupbudget: totalBudget,
          });


          commit('SET_AMOUNT_BUDGET', { expense: totalSpent, allocated: totalBudget, totalUncatorized });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },
    async setStateTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      commit('SET_STATE_TRANSACTION', payload);
      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },
    async getAllUncategorized({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_YEAR_UNCATEGORISE,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then(({
          data,
        }) => {

          commit('SET_UNCATEGORIZE', data.YearlyunCategorize);
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },

    async getAllTeamBudget({ commit }, payload) {

      await apolloClient
        .query({
          query: GET_ALL_TEAM_BUDGET_GQL,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then(({
          data,
        }) => {

          const { totalBudget, totalAllocated, totalSpent } = data.getAllTeamDashboard;
          commit('SET_MY_GROUPS_BUDGET', { amount: totalBudget });
          commit('SET_MY_ALLOCATED_BUDGET', { amount: totalAllocated });
          commit('SET_TOTAL_SPEND_AMOUNT', { expense: totalSpent });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });

      commit('shared/SET_LOADING', false, {
        root: true,
      });
    },
    async getTopMerchantAverageIncreaseData({ commit }, payload) {
      if (payload.enableLoader) {
        commit('shared/SET_LOADING', true, {
          root: true,
        });
      }
      await apolloClient
        .query({
          query: GET_TOP_MERCHANT_AVERAGE_INCREASE_DATA_GQL,
          variables: {
            companyId: payload.companyId,
            filterOffSet: payload.filterOffSet,
          },
          fetchPolicy: 'no-cache',
        }).then(({ data }) => {

          if (payload.enableLoader) {
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          }
          commit('GET_TOP_MERCHANT_AVERAGE_INCREASE_DATA', data.getTopMerchantAverageIncreaseData);
        }).catch((err) => {
          console.log(err);
        });
    },

    async isExtCreditCardConnected({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_CHECK_EXT_CARD,
          variables: {
            companyId: payload.companyId,
          },
          fetchPolicy: 'no-cache',
        }).then(({ data }) => {
          commit('SET_EXT', data.isConnectedExt.status);
        }).catch((err) => {
          console.log(err);
        });
    },

    async dontShowCreditDialog({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_CHECK_EXT_CARD,
          variables: payload,
        })
        .then(({ data }) => {
          console.log('dontShowCreditDialog');
        });
    },
  },

  getters: {
    budgetNotifications: state => state.budgetNotifications,
    teamSpendBudgetAmount2: state => state.teamSpendBudgetAmount2,
    NotificationRequests: state => state.NotificationRequests,
    UpdateRequest: state => state.UpdateRequest,
    SpendNotification: state => state.SpendNotification,
    groupsBudgets: state => state.groupsBudgets,
    allocatedGroupBudget: state => state.allocatedGroupBudget,
    spendAmount: state => state.spendAmount,
    cardUsages: state => state.cardUsages,
    allocatedBudget: state => state.allocatedBudget,
    updateBalance: state => state.updateBalance,
    spendTransaction: state => state.spendTransaction,
    allocatBudget: state => state.allocatBudget,
    catMonthBudget: state => state.catMonthBudget,
    transactionSubscriptionPhysical: state => state.transactionSubscriptionPhysical,
    getListOfUnCategorize: state => state.getListOfUnCategorize,
    moveTransaction: state => state.moveTransaction,
    topMerchantAverageIncreaseData: state => state.topMerchantAverageIncreaseData,
    isExtConnected: state => state.isExtConnected,
  },
};
